export class BillImage 
{
   key: any;
   billImageUrl: any;
   accountIndex: any;

    constructor(key: any, billImageUrl: any, accountIndex: any) {
        this.key=key;
        this.billImageUrl = billImageUrl;
	this.accountIndex = accountIndex;
    }
}
